import React, { useState } from 'react';
import { InstagramIcon, YoutubeIcon, MusicIcon } from 'lucide-react';
export function Footer() {
  const [email, setEmail] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Newsletter signup:', email);
    setEmail('');
  };
  const scrollToSection = (href: string) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <footer className="bg-charcoal py-16 md:py-20" data-id="element-99">
      <div className="max-w-7xl mx-auto px-6" data-id="element-100">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-10 mb-12" data-id="element-101">
          {/* Brand */}
          <div className="lg:col-span-2" data-id="element-102">
            <a href="#inicio" className="font-serif text-2xl text-cream mb-4 block" data-id="element-103">
              Daniel
            </a>
            <p className="font-sans text-cream/60 mb-6 max-w-xs" data-id="element-104">
              Construye. Expande. Diseña.
            </p>
            <div className="flex gap-4" data-id="element-105">
              <a href="#" className="w-10 h-10 rounded-full bg-cream/10 flex items-center justify-center hover:bg-gold/20 transition-colors" aria-label="Instagram" data-id="element-106">
                <InstagramIcon className="w-5 h-5 text-cream" data-id="element-107" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-cream/10 flex items-center justify-center hover:bg-gold/20 transition-colors" aria-label="YouTube" data-id="element-108">
                <YoutubeIcon className="w-5 h-5 text-cream" data-id="element-109" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-cream/10 flex items-center justify-center hover:bg-gold/20 transition-colors" aria-label="Spotify" data-id="element-110">
                <MusicIcon className="w-5 h-5 text-cream" data-id="element-111" />
              </a>
            </div>
          </div>

          {/* Programas */}
          <div data-id="element-112">
            <h4 className="font-sans text-sm uppercase tracking-wider text-gold mb-4" data-id="element-113">
              Programas
            </h4>
            <ul className="space-y-3" data-id="element-114">
              <li data-id="element-115">
                <button onClick={() => scrollToSection('#programas')} className="font-sans text-sm text-cream/60 hover:text-cream transition-colors" data-id="element-116">
                  Ruta Emprendedor
                </button>
              </li>
              <li data-id="element-117">
                <button onClick={() => scrollToSection('#programas')} className="font-sans text-sm text-cream/60 hover:text-cream transition-colors" data-id="element-118">
                  Ruta Ecommerce
                </button>
              </li>
              <li data-id="element-119">
                <button onClick={() => scrollToSection('#programas')} className="font-sans text-sm text-cream/60 hover:text-cream transition-colors" data-id="element-120">
                  Ruta Marca Personal
                </button>
              </li>
              <li data-id="element-121">
                <button onClick={() => scrollToSection('#alma')} className="font-sans text-sm text-cream/60 hover:text-cream transition-colors" data-id="element-122">
                  Alma en Expansión
                </button>
              </li>
            </ul>
          </div>

          {/* Mentorías */}
          <div data-id="element-123">
            <h4 className="font-sans text-sm uppercase tracking-wider text-gold mb-4" data-id="element-124">
              Mentorías
            </h4>
            <ul className="space-y-3" data-id="element-125">
              <li data-id="element-126">
                <button onClick={() => scrollToSection('#mentorias')} className="font-sans text-sm text-cream/60 hover:text-cream transition-colors" data-id="element-127">
                  Mentoría 1:1
                </button>
              </li>
              <li data-id="element-128">
                <button onClick={() => scrollToSection('#mentorias')} className="font-sans text-sm text-cream/60 hover:text-cream transition-colors" data-id="element-129">
                  Mentoría Grupal
                </button>
              </li>
              <li data-id="element-130">
                <button onClick={() => scrollToSection('#mentorias')} className="font-sans text-sm text-cream/60 hover:text-cream transition-colors" data-id="element-131">
                  Programa Premium
                </button>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div data-id="element-132">
            <h4 className="font-sans text-sm uppercase tracking-wider text-gold mb-4" data-id="element-133">
              Legal
            </h4>
            <ul className="space-y-3" data-id="element-134">
              <li data-id="element-135">
                <a href="#" className="font-sans text-sm text-cream/60 hover:text-cream transition-colors" data-id="element-136">
                  Términos de uso
                </a>
              </li>
              <li data-id="element-137">
                <a href="#" className="font-sans text-sm text-cream/60 hover:text-cream transition-colors" data-id="element-138">
                  Política de privacidad
                </a>
              </li>
              <li data-id="element-139">
                <a href="#" className="font-sans text-sm text-cream/60 hover:text-cream transition-colors" data-id="element-140">
                  Política de reembolso
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Newsletter */}
        <div className="border-t border-cream/10 pt-10 mb-10" data-id="element-141">
          <div className="max-w-md" data-id="element-142">
            <h4 className="font-serif text-lg text-cream mb-2" data-id="element-143">
              Únete a Expansión Semanal
            </h4>
            <p className="font-sans text-sm text-cream/60 mb-4" data-id="element-144">
              Reflexiones, estrategias y transmisiones cada semana.
            </p>
            <form onSubmit={handleSubmit} className="flex gap-3" data-id="element-145">
              <input type="email" required placeholder="tu@email.com" value={email} onChange={e => setEmail(e.target.value)} className="flex-1 px-4 py-2.5 bg-cream/10 border border-cream/20 rounded-full font-sans text-sm text-cream placeholder:text-cream/40 focus:outline-none focus:border-gold transition-colors" data-id="element-146" />
              <button type="submit" className="px-5 py-2.5 bg-gold text-charcoal text-sm font-sans font-medium rounded-full hover:bg-gold-light transition-colors" data-id="element-147">
                Suscribir
              </button>
            </form>
          </div>
        </div>

        {/* Bottom */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-center md:text-left" data-id="element-148">
          <p className="font-sans text-sm text-cream/40" data-id="element-149">
            © 2024 Daniel. Todos los derechos reservados.
          </p>
          <p className="font-sans text-sm text-cream/40" data-id="element-150">
            Hecho con propósito.
          </p>
        </div>
      </div>
    </footer>;
}